import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeDivisionRead from './cnaeDivisionRead.action.json' assert { type: 'json' }

const cnaeDivisionReadDefinition = defineReadAutoAction(cnaeDivisionRead, 'cnaeDivision')

export default cnaeDivisionReadDefinition
